import { watchOrReadListService as svc } from '../services/UserList'

export const watchOrReadListController = {
  query,
  statusMap,
  stats,
  getById,
  save,
  remove,
  updateProgress,
  updateStatus,
  updateTotalRewatch,
}

/* ────────── QUERY ────────── */
async function query(userId, listType, options = {}, sortBy = 'start_date') {
  try {
    return await svc.query(userId, listType, options, sortBy)
  } catch (err) {
    console.error(`❌ [controller.query] ${err?.message || err}`)
    throw err
  }
}

/* ────────── STATUS-MAP ────────── */
async function statusMap(userId, listType, ids) {
  try {
    return await svc.statusMap(userId, listType, ids)
  } catch (err) {
    console.error(`❌ [controller.statusMap] ${err?.message || err}`)
    throw err
  }
}

/* ────────── STATS ────────── */
async function stats(userId, listType) {
  try {
    return await svc.stats(userId, listType)
  } catch (err) {
    console.error(`❌ [controller.stats] ${err?.message || err}`)
    throw err
  }
}

/* ────────── CRUD passthroughs (with try / catch) ────────── */
async function getById(userId, listType, anizoneId) {
  try {
    return await svc.getById(userId, listType, anizoneId)
  } catch (err) {
    console.error(`❌ [controller.getById] ${err?.message || err}`)
    throw err
  }
}

async function save(userId, listType, item) {
  try {
    return await svc.save(userId, listType, item)
  } catch (err) {
    console.error(`❌ [controller.save] ${err?.message || err}`)
    throw err
  }
}

async function remove(userId, listType, anizoneId) {
  try {
    return await svc.remove(userId, listType, anizoneId)
  } catch (err) {
    console.error(`❌ [controller.remove] ${err?.message || err}`)
    throw err
  }
}

async function updateProgress(userId, listType, anizoneId, progress) {
  try {
    return await svc.updateProgress(userId, listType, anizoneId, progress)
  } catch (err) {
    console.error(`❌ [controller.updateProgress] ${err?.message || err}`)
    throw err
  }
}

async function updateStatus(userId, listType, anizoneId, status) {
  try {
    return await svc.updateStatus(userId, listType, anizoneId, status)
  } catch (err) {
    console.error(`❌ [controller.updateStatus] ${err?.message || err}`)
    throw err
  }
}

async function updateTotalRewatch(userId, listType, anizoneId, total) {
  try {
    return await svc.updateTotalRewatch(userId, listType, anizoneId, total)
  } catch (err) {
    console.error(`❌ [controller.updateTotalRewatch] ${err?.message || err}`)
    throw err
  }
}
